<template>
<div>
  <Modal class="modal-reg" width="1000" v-model="modal4" :closable="false" :mask-closable="false" :footer-hide="true">
       <div slot="header" class="modal-reg-title">
            娃娃鱼项目外包服务平台服务条款<Icon  type="md-close" @click="closeReg"/>
       </div>
      <div class="modal-reg-body"> 
        <p>欢迎使用由娃娃鱼公司提供的娃娃鱼项目外包服务平台的产品或服务（以下简称“娃娃鱼项目平台服务”）。在您注册成为娃娃鱼项目平台的客户并使用娃娃鱼项目平台服务之前，请仔细阅读以下条款的全部内容（特别是加粗的内容）。<strong>如果您系未满十八周岁的未成年人，则您应在法定代理人或其他监护人的陪同下阅读。</strong></p>
        <p>如您使用娃娃鱼项目平台，即表示您自愿接受本服务条款的全部内容。如您对本服务条款有疑问的，请通过娃娃鱼项目平台网站公布的联系方式进行询问，娃娃鱼公司将向您解释条款内容。如您不同意本服务条款的任意内容，或者无法准确理解娃娃鱼公司对条款内容的解释，请不要注册、开通或以其他任何方式使用娃娃鱼项目平台产品功能或服务。</p>
         <h1>1. 服务条款的确认和接纳</h1>
         <p>1.1 本服务条款内容包括条款正文、本服务条款明确援引的其他协议、娃娃鱼项目平台服务已经发布的或将来可能发布的单项服务条款/说明/公告/标准（如有，以下统称为“服务规则”），以及您确认同意的交易确认页面，所有内容为本服务条款不可分割的组成部分，与条款正文具有同等效力。</p>
          <strong>1.2 如您选择以页面确认或其他任何方式明示或默示表示接受本服务条款，或您以注册、购买、开通等方式使用娃娃鱼项目平台服务，即表示您与娃娃鱼公司已达成协议，自愿接受本服务条款的全部内容，您使用娃娃鱼项目平台服务的行为都应当受本服务条款约束。除另有明确约定外，如您与娃娃鱼公司另行签署电子签名合同或盖章合同的，相关文本与本服务条款有不一致之处，以双方电子签名或盖章文本为准。</strong>
         <p>1.3 本服务条款如由于业务发展或其他原因需要进行修订的，娃娃鱼公司将在娃娃鱼项目平台网站或其他官方平台公布修订版本，您可前往查阅最新版条款内容。在娃娃鱼公司修改上述条款且造成您在本服务条款下权利的实质减少或重大变更后，如果您不接受修改后的条款，您可以选择终止使用娃娃鱼项目平台服务。您继续使用的行为将被视为已接受了修改后的条款。</p>
         <h1>2. 娃娃鱼项目平台帐号注册及使用规则</h1>
         <p>2.1 您可浏览娃娃鱼项目平台网站上的产品或服务介绍，如您希望试用、购买娃娃鱼项目平台服务，您需先登录您的帐号，或注册娃娃鱼公司认可的帐号并登录。您注册登录的帐号是娃娃鱼公司确认您
             身份的唯一依据。娃娃鱼项目平台帐号注册资料包括但不限于您的帐号名称、头像、密码、注册或更新娃娃鱼项目平台帐号时输入的所有信息。
             <br>
             2.2 您在注册娃娃鱼项目平台帐号时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在娃娃鱼项目平台帐号注册资料中出现违法和不良信息。且您保证其在注册和使用帐号时，不得有以下情形：<br>
             2.2.1 违反宪法或法律法规规定的；<br>
             2.2.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
             2.2.3 损害国家荣誉和利益的，损害公共利益的；<br>
             2.2.4 煽动民族仇恨、民族歧视，破坏民族团结的；<br>
             2.2.5 破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
            2.2.6 散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
           2.2.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
           2.2.8 侮辱或者诽谤他人，侵害他人合法权益的；<br>
           2.2.9 含有法律、行政法规禁止的其他内容的。<br>
         </p>
         <p>2.3 注册完成后，请您妥善保存有关帐号和密码，并对该帐号进行的所有活动和行为负责。您同意您提供的真实、准确、合法的娃娃鱼项目平台帐号注册资料是作为认定您与其娃娃鱼项目平台的关联性以及您身份
             <strong>如因您自身原因（包括但不限于转让帐号、与他人共用、自己泄露等）或您所用计算机或其他终端产品感染病毒或木马，而导致帐号密码泄漏、遗失或其他损失后果将由您独自承担。</strong>
         </p>
         <strong>2.4 娃娃鱼公司有权对您提供的账号注册资料进行审查，若发现或者收到举报确认注册资料存在不准确，不真实，或含有违法、不良信息，娃娃鱼公司有权不予注册，并保留终止您使用娃娃鱼项目平台服务的权利。若您以虚假信息骗取账号注册或账号注册资料存在侵权、违法和不良信息的，娃娃鱼公司有权采取通知限期改正、暂停使用、注销登记等措施。对于冒用其他机构或他人名义注册账号名称的，娃娃鱼公司有权注销该账号，并向政府主管部门进行报告。</strong>
         <p>2.5 您若发现自身账号或密码被他人非法使用或有登录、使用异常情况的，应及时通知娃娃鱼公司，娃娃鱼公司将按照本协议或法律规定进行处理。</p>
         <strong>2.6 在法律法规允许的范围内，您同意娃娃鱼项目平台账号所有权，以及与注册、使用娃娃鱼项目平台服务的服务数据和记录，包括但不限于所有注册、登录、消费记录、客户服务记录和相关的使用统计数据，归娃娃鱼公司所有。发生争议时，您同意以娃娃鱼公司的系统数据为准，娃娃鱼公司保证该数据的真实性。</strong>
         <h2>3.服务内容</h2>
         <p>3.1 本服务条款所称的娃娃鱼项目平台服务是指由娃娃鱼公司所有和/或运营的项目外包服务平台，包含需求方发布动画/影视/漫画等内容制作需求，由用户承接制作并交付制作成果等内容。具体服务内容及功能详见娃娃鱼项目平台网站公布的服务项目信息，并以娃娃鱼公司实际提供的为准。<br>
        3.2 您可根据自身情况，自行通过娃娃鱼项目平台网站在线选择承接的项目，选择项目前您需仔细阅读承接的制作项目对应的内容和要求并决定是否承接。您也可以通过娃娃鱼项目平台网站公布的方式与娃娃鱼公司联系，娃娃鱼公司可根据实际合作需要，与您另行接洽并签订服务合同。单独的服务合同可能以电子文档形式展示，也可能是独立的纸质文档形式展示。
        <br>3.3 您需在确认承接后及时完成符合约定标准的制作内容或其他工作成果的交付。制作需求可能有时间限制，若发生您未及时交付、或交付出现数量不足或不符合约定标准等情况的，您将可能无法获得相应的报酬且可能需要对因此产生的损失进行赔偿。<br>
        3.4 您如需签订正式合同的，可根据自身需求，自行通过娃娃鱼项目平台平台点击申请电子签名合同或线下盖章合同。如您选择申请电子签名合同的，即视为您授权娃娃鱼公司采用电子合同的方式在娃娃鱼项目平台平台与您签订您与娃娃鱼公司进行交易需订立的协议，该协议可以有一份或者多份并且每一份具有同等法律效力。如您选择线下盖章合同，您可通过娃娃鱼项目平台网站公布的联系方式与娃娃鱼公司联系，由娃娃鱼公司与您线下签署盖章合同。
         </p>
         <h1>4. 娃娃鱼项目平台使用规则</h1>
         <p>4.1 您有权选择娃娃鱼公司提供的娃娃鱼项目平台产品功能和服务。<strong>除非另有证明，娃娃鱼公司储存在其服务器上的数据是您使用娃娃鱼项目平台服务的唯一有效证据。</strong></p>
         <p>4.2 您应当按照娃娃鱼项目平台官网页面上展示的相应服务说明、技术规范、使用流程、操作文档等内容确定的操作指引使用娃娃鱼项目平台产品功能及服务。在使用过程中，对于您违反相关操作指引所引起的后果将由您自行承担，娃娃鱼公司不承担任何责任。</p>
        <strong>4.3 您应当依照《互联网信息服务管理办法》等相关法律法规的规定时限保留您使用娃娃鱼项目平台服务的应用产品的信息内容及其发布时间、互联网地址（IP）、域名等，您应自行承担未按规定保留相关记录而引起的全部法律后果和责任。</strong>
         <p>4.4 您应遵守相关法律法规政策及服务规则，维护互联网秩序和安全，同时，您不得利用娃娃鱼项目平台服务，实施任何违反国家法律法规政策的行为，也不得为任何违反法律法规政策的行为提供便利：<br>
         4.4.1 违反宪法或法律法规政策规定的；<br>
         4.4.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
         4.4.3 损害国家荣誉和利益的，损害公共利益的；<br>
         4.4.4 歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<br>
         4.4.5 宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的<br>
          4.4.6 煽动民族仇恨、民族歧视，破坏民族团结的；<br>
         4.4.7 破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
         4.4.8 散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
        4.4.9 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
         4.4.10 侮辱或者诽谤他人，侵害他人合法权益的；<br>
         4.4.11 以非法民间组织名义活动的；<br>
        4.4.12 可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等损害未成年人身心健康的；<br>
         4.4.13 散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息的；<br>
              4.4.14 所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；<br>
        4.4.15 含有法律、行政法规禁止或其他违反社会公序良俗的内容的。<br>
        4.5 您应在遵守法律及本服务条款的前提下使用娃娃鱼项目平台服务，不得利用娃娃鱼项目平台服务进行侵害娃娃鱼公司或他人的知识产权或者合法利益的其他行为，包括但不限于：<br>
    
        4.5.1 您不得修改、翻译、出版、改编、出租、转许可、在信息网络上传播或转让娃娃鱼项目平台服务或软件，也不得逆向工程、反编译或以其他方式发现娃娃鱼项目平台服务的任何源代码；<br>
        4.5.2 您不得进行任何改变或试图改变娃娃鱼项目平台服务提供的系统配置或破坏娃娃鱼公司系统安全的行为；<br>
        4.5.3 未经娃娃鱼公司的另行授权，您不得向任何第三方以任何形式提供本服务条款项下服务，包括但不限于转售、转租或转赠娃娃鱼项目平台服务；<br>
      4.5.4 您不应进行其他超出娃娃鱼公司提供的服务范围，可能给娃娃鱼公司带来任何不利影响的行为或者是国家禁止的行为；<br>
        4.5.5 您不得故意避开或者破坏著作权人为保护本软件著作权而采取的技术措施,或实施侵害他人知识产权等任何合法权益的行为，比如私服、外挂等；<br>
       4.5.6 您不得进行任何破坏或试图破坏网络安全的行为,包括但不限于通过钓鱼、病毒、木马、恶意代码等方式，对网站进行恶意扫描、非法侵入系统、非法获取数据等；<br>
       4.5.7您不得在提供委托创作内容或制作成果中使用未经他人授权的作品、素材或其他第三方享有知识产权的内容，亦不得在完成上述创作内容或制作成果的过程中使用盗版软件。如因您在完成委托工作的过程中或创作的内容及制作成果包含侵权内容导致娃娃鱼公司及其关联公司或第三方产生损失的，应当承担侵权责任。<br>
          </p>
          <h2>4.6 您不得利用娃娃鱼项目平台服务提供任何不经网络审查或依靠技术手段成为境内获取境外非法信息的途径，亦不得将娃娃鱼项目平台服务所提供的服务器资源用作虚拟服务器、或用作磁盘空间出租、或用作虚拟代理服务器或垃圾邮件服务器。</h2>
          <p>4.7 您不得在娃娃鱼项目平台服务之上安装、使用盗版软件或其他非正规来源的软件；若您违反本条款约定，造成娃娃鱼项目平台服务不稳定或者服务不可用的，或者造成数据灭失等后果的，您应自行承担由此造成的全部损失。</p>
          <h2>4.8 如果您通过娃娃鱼项目平台提供的服务进行经营或者非经营性活动需要获得国家有关部门许可或批准的，应当获得有关的许可或批准。如您未办理必要审批而开展此类业务的，娃娃鱼公司有权中止或终止向您提供服务而无需承担任何责任。</h2>
          <h2>4.9 娃娃鱼公司不保证服务毫无瑕疵，您同意：即使娃娃鱼项目平台提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为娃娃鱼项目平台违约。娃娃鱼公司对您使用娃娃鱼项目平台服务不作任何明示或暗示的保证，包括但不限于本服务的适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途等。</h2>
        <p>4.10 对于您利用娃娃鱼项目平台所发布的信息，娃娃鱼公司保留依据国家相关法律法规对该信息进行关键词过滤的权利，如发现您发布的内容明确存在违反国家相关法律法规的，娃娃鱼公司有权作出包括但不限于劝阻、拦截、直至向有关公安部门举报等行为。</p>
       <h2>4.12 如果您违反本服务条款给娃娃鱼公司或其他第三方造成损失的，您须承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在娃娃鱼公司首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予娃娃鱼公司等额的赔偿。若您违反以上规定，娃娃鱼公司有权作出独立判断立即暂停或终止对您提供部分或全部服务，包括冻结、取消您的帐号的使用权限等措施。</h2>
       <h1>5. 娃娃鱼项目平台的服务费用</h1>
       <p>5.1 娃娃鱼项目平台服务的计费方式及价格等信息，以娃娃鱼项目平台具体服务项目网页内双方另行确认的计费和价格信息为准。您可根据自身需求，自行选择订单并按照网站列明的价格或按照双方另行商定的价格订立合同、获取订单并通过网站列明的途径提交委托创作成果，经需求方确认后获得相应费用。</p>
       <p>5.2 您登录娃娃鱼项目平台平台（包括但不限于娃娃鱼项目平台网站）后，可以通过管理后台进行查看帐户信息、订单信息、申请订单即确认订单、获知订单进度（含中止或终止）、查看费用及根据指引确认费用支付途径和结算情况等操作。</p>
       <h2>5.3 您在确认承接具体项目订单之前，需要按照娃娃鱼项目平台指引完成实名认证，包括提交有效的身份证件或法人身份证明，并完成对支付信息的填写。您填写的支付信息需与您的实名认证信息一致，支付信息 是您费用结算的固定途径，如信息不准确或变更的，您应当及时书面通知或根据娃娃鱼项目平台的指引进行修改。因信息不准确或不可用造成的付款延迟及其他后果，由您自行承担责任。</h2>
       <h2>5.4如您以法人身份完成实名认证并承接服务项目的，则在收款前需要按照娃娃鱼项目平台内提示的信息开具并向发布服务项目的需求发布方提供相应金额的合规增值税专用发票，不能及时提供合规发票的，需求发布方可延后支付。如您以个人身份完成实名认证并承接服务项目的，您可以向税务主管机关申请代开发票，如不能完成代开发票的、需求发布方在支付前可按照中国税法的规定代扣代缴个人所得税，如涉及到其他税费的，应由您自行向税务机关申报缴纳。</h2>
       <h1>6. 娃娃鱼项目平台及服务的变更和终止</h1>
       <h2>6.1 娃娃鱼公司始终在不断变更和改进娃娃鱼项目平台服务。您理解并同意，娃娃鱼公司可能会增加或删除部分功能或服务，也可能暂停或彻底停止全部功能或服务，但娃娃鱼公司应该提前 30 天在娃娃鱼项目平台网站或产品其他平台的适当位置公告重大变更的内容。</h2>
       <p>6.2 如您继续使用娃娃鱼项目平台服务，则视为您接受上述变更。如您不接受上述变更，您有权继续按照变更前的内容和标准使用变更部分的娃娃鱼项目平台服务直至该部分服务对应的有效订单下的预付款耗尽或停止使用娃娃鱼项目平台服务。如您选择停止使用娃娃鱼项目平台服务，娃娃鱼公司应与您进行结算，并且您应将业务数据迁出。</p>
      <h2>6.3 您同意娃娃鱼公司根据自身商业决策等原因可能会选择终止娃娃鱼项目平台服务。如有此等情形发生，娃娃鱼公司会采取公告的形式通知您相关处理措施。</h2>
      <h2>6.4 经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者娃娃鱼公司根据自身的判断，认为您的行为违反本服务条款内容或娃娃鱼公司不时公布的使用规则等内容（包括但不限于违反法律法规规定、严重违反本服务条款等），则娃娃鱼公司有权中止或终止向您提供服务，并不承担任何责任。</h2>
       <h1>7. 责任承担与责任限制</h1>
       <p>7.1 因您违反本协议约定产生的责任和后果由您自行承担，若给娃娃鱼公司或第三方造成损失的，您应当予以赔偿。</p>
       <h2>7.2 您未按协议约定履行交付义务的，娃娃鱼公司除有权无需另行通知而中止、终止需求项目合作外，还有权采取包括但不限于以下一种或多种措施：</h2>
        <h2>7.3.1 要求您依约定交付创作内容或制作成果，并应按每日/千分之一的标准向需求发布方支付违约金。若您逾期付款超过十日，娃娃鱼公司有权无需另行通知您即可单方解除本协议及需求项目相关的约定。</h2>
       <h2>7.3.2 如您的账户有未结算的同一需求发布方应付费用余额的，则娃娃鱼公司有权无需另行通知您，而直接将您账户的余额用于抵扣违约金。</h2>
        <h2>7.3.3 删除您基于使用娃娃鱼项目平台服务而存储或产生的部分或全部信息和数据。</h2>
        <h2>7.4 在任何情况下，对您因使用或不能使用服务所产生的任何间接的、偶然的、特殊的或惩罚性的损害及损失，包括预期利润的丧失、机会损失、声誉/商誉损害、贸易中断、商业信息的丢失等，娃娃鱼公司不承担责任。</h2>
       <h2>7.5 在任何情况下，娃娃鱼公司的最大赔偿责任不超过违约对应之项目服务费用总额。若本条款与双方其他约定或娃娃鱼项目平台服务规则冲突或不一致的，以本条约定为准。</h2>
    <h1>8. 不可抗力和其他免责事由</h1>
    <p>8.1 您理解并同意，因不可抗力使服务发生中断，不视为娃娃鱼公司违约，若由此给您造成的损失娃娃鱼公司将予以免责。不可抗力系指不能预见、不能避免并不能克服的客观情况，包括但不限于：<br>
    8.1.1 天灾、疫情、战争、暴乱、法律法规或政府政策、指令的变更；<br>
   8.1.2 因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，亦视为不可抗力；<br>
    8.2 您理解并同意，因以下事由导致娃娃鱼项目平台服务中断的，不视为娃娃鱼公司违约，若由此给您造成的损失娃娃鱼公司将予以免责：<br>
   8.2.1 娃娃鱼公司在进行机房维护、设备检修、系统升级或优化时，需要中断服务；<br>
   8.2.2 由于您自身或第三方的原因导致的服务中断、终止，包括您操作不当、第三方产品或服务提供者的软硬件故障等。 </p>
   <h1>9. 信息安全与保密义务</h1>
   <h2>9.1 保护您的信息安全是娃娃鱼公司的一项基本政策，娃娃鱼公司会按照《网络安全法》的规定保护您的相关信息。所以，娃娃鱼公司不会公开或透露您的注册资料及采集、存储、上传到娃娃鱼项目平台服务中的非公开信息，除非娃娃鱼公司在诚信的基础上认为透露这些信息在以下几种情况是必要的：</h2>
    <h2>9.1.1 事先获得您的授权；或</h2>
    <h2>9.1.2 在国家有关机关依法查询或调阅时，遵守有关法律规定或政策文件要求，向有关机关或第三方提供您的注册资料、您在娃娃鱼项目平台服务器或者网页上发布、存储、传播或娃娃鱼公司在娃娃鱼项目平台服务中采集的信息内容及其发布时间、互联网地址或者域名等；或</h2>
     <h2>9.1.3 娃娃鱼公司可能会与第三方合作向您提供娃娃鱼项目平台的相关服务，在此情况下，如该第三方同意承担与娃娃鱼公司同等的保护您信息安全的责任，则娃娃鱼公司可将您的信息提供给该第三方；或</h2>
      <h2>9.1.4 保持维护娃娃鱼公司的知识产权和其他重要权利；或</h2>
      <h2>9.1.5 在紧急情况下竭力维护您和社会大众的信息安全；或</h2>
      <h2>9.1.6 根据本服务条款相关规定或者娃娃鱼公司认为必要的其他情况。</h2>
      <p>9.2 您保证，您采集、存储、上传到娃娃鱼项目平台服务中，或者由娃娃鱼公司在娃娃鱼项目平台服务采集的信息内容，为您依法收集、获取或产生的数据。您承诺上述所有数据已通过合法有效的方式取得相关数据主体的明示授权（包括告知相关主体其数据收集的目的、范围及使用方式等），并确保娃娃鱼公司为提供娃娃鱼项目平台服务对前述数据进行采集、上传、存储、分析和分发等任何处理均符合相关法律法规的要求，不存在任何违法、侵权或违反您与第三方的合同约定的情形。因您的数据的产生、收集、处理、使用等任何相关事项存在违反法律法规等情况而造成的全部结果及责任均由您自行承担，并且，娃娃鱼公司有权随时全部或部分终止向您提供娃娃鱼项目平台服务，以及要求您赔偿由此给娃娃鱼公司造成的全部损失。</p>
       <p>9.3 您对于因使用娃娃鱼项目平台服务而了解或接触到的娃娃鱼公司的商业秘密及其他机密和信息，相关技术、程序、资料、文档，协议内容、价款及及往来文件（以下统称“保密信息”）均应保守秘密；非经娃娃鱼公司书面同意，不得向第三方泄露、给予或转让该保密信息。保密协议不因本服务条款的终止而终止。</p>
      <h1>10. 出口管制与制裁合规</h1>
      <p>您应遵守所有适用的由联合国、中国、美国及任何其他国家（地区）、国际组织所制定并执行的有关出口管制与经济贸易制裁方面的制裁决议、法律与法规（以下统称“出口管制与制裁法律法规”）。您承诺您不是前述出口管制与制裁法律法规限制、制裁的对象，也未直接或间接为被限制、制裁的对象提供资金、商品或服务；非经相关主管机关许可，您及您授权使用娃娃鱼项目平台服务的个人或实体不会通过娃娃鱼公司提供的产品或服务向被限制、制裁的对象提供受控的技术、软件或服务，或以任何方式使得娃娃鱼公司违反出口管制与制裁法律法规。</p>
       <h1>11. 知识产权</h1>
       <p>11.1 娃娃鱼项目平台的专利、版权、设计等知识产权，以及与娃娃鱼项目平台服务相关的所有信息内容，包括但不限于文字、图片、档案、资讯、资料、网站架构、页面设计均由娃娃鱼公司依法享有知识产权。娃娃鱼公司提供娃娃鱼项目平台服务时所涉及到的内容包括但不限于：产品、技术、程序、资料、文档、界面设计、数据资料、账号等，其知识产权均归属于娃娃鱼公司。<strong>未经娃娃鱼公司产品书面同意，您不能为任何营利或非营利性的目的擅自复制、剽窃、传播、仿造这些内容、或创造与内容有关的派生产品、或以转让、出租、抵押、处置、许可的方式授权第三方实施、利用和转让上述知识产权。您也不得逆向工程、反编译或试图以其他方式发现娃娃鱼项目平台服务的任何源代码。</strong></p>
        <p>11.2 娃娃鱼项目平台服务的名称、娃娃鱼项目平台网站的Logo、“娃娃鱼”、“娃娃鱼项目平台”等文字、图形以及娃娃鱼公司的其他标志等，均为娃娃鱼公司之商标或美术作品（以下统称“娃娃鱼标识”）。未经娃娃鱼公司事先书面同意，您不得将娃娃鱼标识及娃娃鱼公司享有相关权利的其他标识以不合法或不合理的任何方式使用或作其他处理，也不得向他人表明用户有权使用娃娃鱼标识。</p>
        <p>11.3 您应尊重娃娃鱼公司和第三方的知识产权和其他合法权利/权益，并保证在发生侵犯前述权益的违法事件时，保护娃娃鱼公司及其雇员、股东、合作伙伴等免于因该等事件受到影响或损失，娃娃鱼公司保留在您侵犯娃娃鱼公司及/或其他第三方的合法权利/权益时终止向您提供服务并不退还任何款项的权利。</p>
       <h2>11.4 娃娃鱼公司尊重知识产权，在获得您同意的情况下，娃娃鱼公司可能在娃娃鱼项目平台网站及相关宣传材料内、在全球范围内、使用您和您产品的名称、Logo 或商标用于宣传或推广用途。 任何组织或个人认为娃娃鱼项目平台网站的网页内容，可能侵犯其合法权益的，可向娃娃鱼公司提出书面权利通知，娃娃鱼公司将在收到知识产权权利人合格通知后依法尽快处理。</h2>
       <h2>11.5 娃娃鱼公司尊重知识产权并注重保护您享有的各项权利。在娃娃鱼项目平台所含服务中，您可能需要通过发表文字、图形、音视频等各种方式向娃娃鱼项目平台平台提供内容。在此情况下，除另有约定外您明确因承接需求项目而创作的所有内容，包含成品与半成品的全部知识产权归需求方所有。</h2>
     <h1>12. 适用的法律</h1>
     <h2>本条款适用中华人民共和国的法律，并且排除一切冲突法规定的适用。 如使用本条款项下服务中出现纠纷的，您与娃娃鱼公司应友好协商解决，若协商不成，您同意将纠纷提交杭州仲裁委员会仲裁解决，并由3名仲裁员进行审理。仲裁裁决是终局的，对双方均有约束力。若单项条款与本服务条款在管辖约定内容上存在冲突，则在单项条款约束范围内应以单项条款为准。</h2>
      <h1>13. 其他</h1>
      <p>13.1 本服务条款自发布之日起实施，并构成您和娃娃鱼公司之间的共识。娃娃鱼公司不行使、未能及时行使或者未充分行使本服务条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响娃娃鱼公司在将来行使该权利。</p>
    <p>13.2 如本服务条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力，娃娃鱼公司及用户均应尽力使该条款设定的本意得到实现。</p>
     <h2>13.3 娃娃鱼公司有权以提前30天在娃娃鱼项目平台网站公布或给您发站内通知或书面通知的方式将本服务条款的权利义务全部或者部分转移给关联公司。</h2>
     <p>13.4 本服务条款中的标题仅为方便而设，不作为解释本服务条款的依据。</p>
     <p>13.5 如果您对本服务条款内容有任何疑问，请发送邮件至我们的客服邮箱：（【kefu@wawayu.tv】）。</p>
    </div> 
      <div style="padding:1px;">
           <button class="btn" :class="{'active':time>0}" @click="regSubmit">同意并继续 <span v-if="time>0">({{time}} s )</span></button>
      </div>
    </Modal>
</div>
</template>
<script>
export default {
    props:{
        modal4:{
            type:Boolean,
            default:false
        },
        time:{
             type:Number,
            default:5
        }
    },
    data(){
        return{
         
        }
    },
    mounted(){
    //  this.timer=setInterval(()=>{
    //       this.time--;
    //       if(this.time==0){
    //           clearInterval(this.timer)
    //       }
    //   },1000)
    },
    methods:{
        regSubmit(){//注册
           this.$emit('click',true)
        },
        closeReg(){
            this.$emit('click',false)
        }
    }
}
</script>
<style lang="less" scoped>

.modal-reg{
    color: #000;
  .modal-reg-title{
        background-color:#F0F2F1;
        text-align: center;
        padding:20px;
        color: #AAAAAA;
        font-size: 20px;
        i{
            float: right;
            font-size: 25px;
            cursor: pointer;
        }
    }
    .modal-reg-body{
        padding:0px 46px;
        height: 600px;
        overflow: auto;
        p{
            font-size: 18px;
            line-height: 30px;
        }
        strong{
             font-size: 18px;
        }
        h2{
            font-size: 18px;
        }
        h1{
            font-size: 20px;
        }
    }
    .btn{
        width: 422px;
        height: 37px;
        color: #fff;
        background-color: #056DC2;
        text-align: center;
        border:none;
        margin:20px auto;display: block;
    }
    .active{
             background-color: #AEDAFD;
    }
   
}
 
</style>



// WEBPACK FOOTER //
// src/components/agree-modal.vue